<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import * as focusTrap from 'focus-trap'

const checkCanFocusTrap = (trapContainers) => {
  const results = trapContainers.map((trapContainer) => {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const visible = getComputedStyle(trapContainer).visibility !== 'hidden'
        if (visible && trapContainer.children.length) {
          resolve()
          clearInterval(interval)
        }
      }, 5)
    })
  })
  // Return a promise that resolves when all the trap containers are able to receive focus
  return Promise.all(results)
}

export default {
  name: 'renderless-focus-trap',
  setup (props, { slots }) {
    const element = ref(null)
    let trap
    onMounted(() => {
      trap = focusTrap.createFocusTrap(element.value, {
        allowOutsideClick: true,
        checkCanFocusTrap
      })
      trap.activate()
    })
    onBeforeUnmount(() => trap.deactivate())
    return () => slots.default({ element })
  }
}
</script>
